// ══════════════ SÉLECTEURS RAPPORT / CONTRÔLE LIBRE ══════════════
// Extrait de GerantClientUI.jsx (refacto étape C — briques terrain, 07/07/2026).
// RepLibreSelector et ControleLibreSelector sont utilisés ensemble par GerantUI et StaffUI
// (déclenchement d'un rapport de ménage ou d'un contrôle qualité sans passer par une tâche planifiée).
// Feuilles indépendantes : aucune référence de l'un vers l'autre, ni vers un composant
// interne encore non extrait de GerantClientUI.
import React, { useState, useMemo } from 'react';
import { M } from "./M.jsx";

// ─── Sélecteur bien/date pour rapport libre ─────────────────────
function RepLibreSelector({biens,st,rep,bid,setBid,date,setDate,onConfirm,onClose}){
  const [tacheChoisie,setTacheChoisie]=useState('');
  const tachesMenage=useMemo(()=>
    (st||[]).filter(t=>t.bid===bid&&t.date===date&&['full','quick','linge','correction'].includes(t.type)),
    [st,bid,date]
  );
  const tacheLiee=tachesMenage.find(t=>t.id===tacheChoisie)||tachesMenage[0]||null;
  const existingRep=tacheLiee?rep.find(r=>r.tid===tacheLiee.id):null;
  const handleOuvrir=()=>{
    const fakeTache=tacheLiee?tacheLiee:{id:null,bid,type:'full',date};
    onConfirm(fakeTache);
  };
  return(<M onC={onClose} title="🧹 Rapport de ménage" col="var(--or)" wide ch={
    <div style={{display:'flex',flexDirection:'column',gap:14}}>
      <div>
        <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Appartement</label>
        <select value={bid} onChange={e=>setBid(e.target.value)} className="inp" style={{width:'100%'}}>
          {(biens||[]).map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      </div>
      <div>
        <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Date du ménage</label>
        <input type="date" value={date} onChange={e=>setDate(e.target.value)} className="inp" style={{width:'100%'}}/>
      </div>
      {tachesMenage.length>1&&(
        <div>
          <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Tâche associée</label>
          <select value={tacheChoisie} onChange={e=>setTacheChoisie(e.target.value)} className="inp" style={{width:'100%'}}>
            {tachesMenage.map(t=><option key={t.id} value={t.id}>{t.type==='full'?'Ménage complet':t.type==='quick'?'Ménage rapide':t.type==='linge'?'Linge':'Correction'} — {String(t.sh).padStart(2,'0')}:{String(t.sm||0).padStart(2,'0')}</option>)}
          </select>
        </div>
      )}
      {tachesMenage.length===1&&<div style={{fontSize:12,background:'#e1f7ee',borderRadius:8,padding:'8px 12px',color:'#1e6e3d'}}>
        ✅ Rattaché à : {tachesMenage[0].type==='full'?'Ménage complet':tachesMenage[0].type==='quick'?'Ménage rapide':tachesMenage[0].type==='linge'?'Linge':'Correction'} à {String(tachesMenage[0].sh).padStart(2,'0')}:{String(tachesMenage[0].sm||0).padStart(2,'0')}
      </div>}
      {tachesMenage.length===0&&<div style={{fontSize:12,background:'#fff4d6',borderRadius:8,padding:'8px 12px',color:'#92400e'}}>
        ⚠️ Aucune tâche ménage ce jour-là. Le rapport sera enregistré sans tâche liée.
      </div>}
      {existingRep&&<div style={{fontSize:12,background:'#dbeeff',borderRadius:8,padding:'8px 12px',color:'#1e5fa8'}}>
        ℹ️ Un rapport existe déjà pour cette tâche — vous allez le modifier.
      </div>}
      <button onClick={handleOuvrir} disabled={!bid||!date} className="btn bmn" style={{marginTop:4}}>Ouvrir le rapport →</button>
    </div>
  }/>);
}

// ─── Sélecteur bien pour contrôle libre ─────────────────────────
function ControleLibreSelector({biens,rep,bid,setBid,onConfirm,onClose}){
  const derniersRapports=useMemo(()=>
    (rep||[]).filter(r=>r.bid===bid&&r.sub&&!r.hidAdmin).sort((a,b)=>b.sub.localeCompare(a.sub)),
    [rep,bid]
  );
  const rapportLie=derniersRapports[0]||null;
  return(<M onC={onClose} title="🔍 Contrôle appartement" col="var(--mn)" ch={
    <div style={{display:'flex',flexDirection:'column',gap:14}}>
      <div>
        <label style={{fontSize:12,fontWeight:600,display:'block',marginBottom:4}}>Appartement</label>
        <select value={bid} onChange={e=>setBid(e.target.value)} className="inp" style={{width:'100%'}}>
          {(biens||[]).map(b=><option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      </div>
      {rapportLie
        ?<div style={{fontSize:12,background:'#e1f7ee',borderRadius:8,padding:'8px 12px',color:'#1e6e3d'}}>
            ✅ Rattaché au rapport soumis le {new Date(rapportLie.sub).toLocaleDateString('fr-FR',{day:'2-digit',month:'2-digit',year:'numeric'})}
          </div>
        :<div style={{fontSize:12,background:'#fff4d6',borderRadius:8,padding:'8px 12px',color:'#92400e'}}>
            ⚠️ Aucun rapport soumis pour ce bien. Le contrôle sera enregistré sans rapport lié.
          </div>
      }
      <button onClick={()=>onConfirm(bid,rapportLie?.id||null)} disabled={!bid} className="btn bmn">
        Ouvrir le contrôle →
      </button>
    </div>
  }/>);
}

export { RepLibreSelector, ControleLibreSelector };
